import { useCallback } from 'react';

import { PageTitle } from '@dec/shared';
import { Transparency } from 'react-bootstrap-icons';
import { useNavigate } from 'react-router-dom';

import { type IdValue } from '@/app/modules/TaxStatement/FormVersion/types';

import { DisbursementPendingTransactionsCard } from '../../components/DisbursementPendingTransactionsCard';
import { DisbursementStatsCard } from '../../components/DisbursementStatsCard';
import { PendingDisbursementsCard } from '../../components/PendingDisbursementCard';
import { type DisbursementContent } from '../../models/Disbursement';
import { disbursementService } from '../../services/disbursement.service';

import { DisbursementForm } from './form';

export const CreateDisbursementPage = () => {
  const navigate = useNavigate();

  const handleSubmit = async (values: DisbursementContent) => {
    const id: IdValue = await disbursementService.createDisbursement(values);

    navigate(`/disbursement/manage/${id.id}/success`);
  };

  const handleCancel = useCallback(() => {
    console.log('cancel');
  }, []);

  return (
    <>
      <PageTitle title="Disbursement" subtitle="Between jurisdictions" icon={Transparency} />
      <div>
        <div className="mt-5 mb-3">
          <div className="card">
            <div className="card-body">
              <DisbursementStatsCard />
            </div>
          </div>
        </div>

        <DisbursementPendingTransactionsCard />

        <div className="mt-5 mb-3">
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-4">
                  <PendingDisbursementsCard />
                </div>
                <div className="col-8">
                  <DisbursementForm onSubmit={handleSubmit} onCancel={handleCancel} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
